import React, { useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';

import PagesHeroSection from '../../../components/pagesHeroSection/pagesHeroSection';
import SEOUpdater from '../../../utils/hoc/SEOUpdater';

import '../immigrationPage/immigrationPage.scss';
import { Col, Row } from 'react-bootstrap';

const PersonalInjuryPage = () => {
  const { t } = useTranslation('personalInjury');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="services-page">
      <SEOUpdater page="personalInjury" />
      <PagesHeroSection page={t('pageTitle')} />

      <div className="services-section text-center">
        <div className="container">
          <h2 className="section-title">{t('heroTitle')}</h2>
          <p>
            <Trans i18nKey="intro.p1" t={t} components={{ 1: <b /> }} />
          </p>
          <p>
            <Trans i18nKey="intro.p2" t={t} components={{ 1: <b /> }} />
          </p>
          <div className="underline mx-auto mb-4"></div>
        </div>
      </div>

      <div className="services-content">
        <div className="container">
          <Row>
            <Col md={6}>
              <h3>{t('sections.carAccidents.title')}</h3>
              <p>{t('sections.carAccidents.text')}</p>
            </Col>

            <Col md={6}>
              <h3>{t('sections.slipFall.title')}</h3>
              <p>{t('sections.slipFall.text')}</p>
            </Col>

            <Col md={6}>
              <h3>{t('sections.dogBites.title')}</h3>
              <p>{t('sections.dogBites.text')}</p>
            </Col>

            <Col md={6}>
              <h3>{t('sections.pedestrian.title')}</h3>
              <p>{t('sections.pedestrian.text')}</p>
            </Col>

            <Col md={6}>
              <h3>{t('sections.bikeMotor.title')}</h3>
              <p>{t('sections.bikeMotor.text')}</p>
            </Col>

            <Col md={6}>
              <h3>{t('sections.hitRun.title')}</h3>
              <p>{t('sections.hitRun.text')}</p>
            </Col>
          </Row>

          <div className="section-footer pt-5">
            <p className="text-center">{t('sections.footer')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalInjuryPage;
